// extracted by mini-css-extract-plugin
module.exports = {"card":"BasketPreviewCard_card__fp3rw","treatmentName":"BasketPreviewCard_treatmentName__LLg32"};